import { render, staticRenderFns } from "./PromoterAddressUpdateForm.vue?vue&type=template&id=56e0b68c&scoped=true&"
import script from "./PromoterAddressUpdateForm.vue?vue&type=script&lang=js&"
export * from "./PromoterAddressUpdateForm.vue?vue&type=script&lang=js&"
import style0 from "./PromoterAddressUpdateForm.vue?vue&type=style&index=0&id=56e0b68c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56e0b68c",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAutocomplete } from 'vuetify/lib/components/VAutocomplete';
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VForm } from 'vuetify/lib/components/VForm';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VAutocomplete,VBtn,VCol,VForm,VIcon,VRow,VTextField})
